import React, { useMemo } from "react";
import {useTranslation} from "react-i18next";
import EarthSectionBase from "./EarthSectionBase";

import Ceiling from "../../images/assets/underground/UNDERGROUND_CEILING.webp"
import Volcano from "../../images/assets/underground/UNDERGROUND_VOLCANO.webp"
import Floor from "../../images/assets/underground/UNDERGROUND_FLOOR.webp"

import coin from "../../images/assets/shared/R_COIN.svg";
import CollectibleCoin, {getRandomCoinHover} from "../shared/CollectibleCoin";

export default function Earth ({
    layer,
    collectedCoinIds = [],
    onCoinCollect,
}) {
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover(), getRandomCoinHover(), getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "earth-coin-1", className: "earth-coin", style: coinStyles[0] },
        { id: "earth-coin-2", className: "earth-coin2", style: coinStyles[1] },
        { id: "earth-coin-3", className: "earth-coin3", style: coinStyles[2] },
    ]

    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={"left-aligned"}
        >
            <img src={Ceiling} alt="" className={'background-img earth-ceiling'} />
            <img src={Volcano} alt="" className={'background-img earth-volcano'} />
            <img src={Floor} alt="" className={'background-img earth-floor'} />
            <img src={Floor} alt="" className={'background-img earth-floor2'} />

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <h1 className="section-title experience-title-position">{t('experienceTitle')}</h1>
            <p className="experience-intro-paragraph">{t('experienceParagraph')}</p>
        </EarthSectionBase>
    )
}